import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ChakraProvider } from '@chakra-ui/react';

import { theme } from '../styles/theme';

const queryClient = new QueryClient();
export default function DependencyProvider({
    children,
}: React.PropsWithChildren) {
    return (
        <div>
            <QueryClientProvider client={queryClient}>
                <ChakraProvider theme={theme}>{children}</ChakraProvider>
            </QueryClientProvider>
        </div>
    );
}
